import { render, staticRenderFns } from "./adv.vue?vue&type=template&id=25827db4&scoped=true"
import script from "./adv.vue?vue&type=script&lang=js"
export * from "./adv.vue?vue&type=script&lang=js"
import style0 from "./adv.vue?vue&type=style&index=0&id=25827db4&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25827db4",
  null
  
)

export default component.exports